import { createQueryStringHook } from "./useQueryState";

export const vehicleModelIdParamName = "vehicleModelId";

export const useVehicleModelIdParam = createQueryStringHook(
  vehicleModelIdParamName,
  "",
);

/**
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rca.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rfc.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/tfc.md
 */
